import { GalleryCarouselProps, TCarouselFields, TFullscreenCarouselFields } from '../types/gallerycarousel.types';

export class GalleryCarouselModel {
    private readonly fields?: TFullscreenCarouselFields | null;

    constructor(props: GalleryCarouselProps) {
        this.fields = props?.fields || null;
    }

    get carouselSlide(): Array<TCarouselFields> | undefined {
        return this.fields?.items;
    }

    get isUnreleased(): boolean {
        return !!this.fields?.isComponentUnreleased;
    }
}
